import { MerchantOrderTypeEnum } from '@/graphql/generatedTypes';

/**
 * Order types that may carry STORE_ASSET lines. Mirrors STORE_ASSET_ORDER_TYPES
 * in colugo's merchantOrderCoreUtils — the eventless outbound types that produce
 * an open-system picking job, so a scanned store asset has a bucket to fill and
 * is booked to the target store on delivery.
 *
 * colugo's assertItemTypeLinesAllowedOnOrder rejects an ItemType line on any
 * other order type the moment the order is saved through updateOpsOrder, so keep
 * the two lists in step.
 */
export const STORE_ASSET_ORDER_TYPES: MerchantOrderTypeEnum[] = [
  MerchantOrderTypeEnum.Resupply,
  MerchantOrderTypeEnum.Onboarding,
  MerchantOrderTypeEnum.OnboardingS,
  MerchantOrderTypeEnum.OnboardingM,
  MerchantOrderTypeEnum.OnboardingL,
  MerchantOrderTypeEnum.Special,
  MerchantOrderTypeEnum.Sample,
  MerchantOrderTypeEnum.WarehouseTransfer,
];

export function orderTypeAllowsStoreAssets(
  orderType: MerchantOrderTypeEnum | null | undefined,
): boolean {
  return orderType != null && STORE_ASSET_ORDER_TYPES.includes(orderType);
}
